export default {
  basename: "/",
  defaultPath: "/",
}